import ApiService from '../../service/apiServiceMasterProject.js';
import ApiServiceMasterCache from '../../service/apiServiceMasterCache.js';

const querystring = require('querystring')
var CategoryService = {

    getBackLogMenu: function($data) {
        return new Promise(function(resolve, reject) {
            let $options = {};
            $options.url = "getBackLogMenu"
            $options.method = "get"

            if ($data) {
                $options.url = "getBackLogMenu?" + querystring.stringify($data)
                console.log($options.url)
            }
            ApiService.request($options)
            .then(response => {
                console.log('test');
                resolve(response.data.data)
            }).catch(error => {
                reject(error);
            })
        });
    },

    findAll: function($data) {
        return new Promise(function(resolve, reject) {
            let $options = {};
            $options.url = "categories"
            $options.method = "get"

            if ($data) {
                $options.url = "categories?" + querystring.stringify($data)
                console.log($options.url)
            }
            ApiServiceMasterCache.request($options)
            .then(response => {
                console.log('test');
                resolve(response.data.data)
            }).catch(error => {
                reject(error);
            })
        });

    },
    

    categoryById: function($data) {
        return new Promise(function(resolve, reject) {
            let $options = {};
            $options.url = "categoryById"
            $options.method = "get"

            if ($data) {
                $options.url = "categoryById?" + querystring.stringify($data)
                console.log($options.url)
            }
            ApiServiceMasterCache.request($options)
            .then(response => {
                console.log('test');
                resolve(response.data.data)
            }).catch(error => {
                reject(error);
            })
        });

    },
  
    findOne: function($data) {
        return new Promise(function(resolve, reject) {
            let $options = {};
            $options.url = "categories/" + $data
            console.log($options.url)
            $options.method = "get"
            if (!$data) {
                $options.data = $data
            }
            ApiServiceMasterCache.request($options)
                .then(response => {
                    // console.log('Gpt the data');
                    resolve(response.data.data)
                }).catch(error => {
                    reject(error);
                })
        });

    },
    update: function($data) {
        return new Promise(function(resolve, reject) {
            let $options = {};
            $options.data = $data
            $options.url = "categories/" + $data.id;
            $options.method = "post"
            console.log($options)
            ApiService.request($options)
                .then(response => {
                    resolve(response)
                }).catch(error => {
                    reject(error)
                });
        })
    },
    save: function($data) {
        return new Promise(function(resolve, reject) {
            var $options = {};
            $options.data = $data
            $options.url = "categories/" + $data.id;
            $options.method = "post"
            console.log($options)
            ApiService.request($options)
                .then(response => {
                    resolve(response)
                }).catch(error => {
                    reject(error)
                });
        });
    },

    create: function($data) {
        return new Promise(function(resolve, reject) {
            var $options = {};
            $options.data = $data
            $options.url = "categories";
            $options.method = "post"
            console.log($options)
            ApiService.request($options)
                .then(response => {
                    resolve(response)
                }).catch(error => {
                    reject(error)
                });
        });
    }
};
export default CategoryService;